import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import RegistrationForm from "./components/RegistrationForm";
import SuccessPage from "./components/SuccessPage";
import "./App.css";

function App() {
  const [marketplaceToken, setMarketplaceToken] = useState(null);

  useEffect(() => {
    console.log("=== AWS Marketplace Registration Debug ===");
    console.log("Full URL:", window.location.href);
    console.log("Query String:", window.location.search);

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("x-amzn-marketplace-token");

    console.log("Extracted Token:", token || "NOT FOUND");
    console.log("All URL Parameters:", Object.fromEntries(urlParams));
    console.log("==========================================");

    if (token) {
      setMarketplaceToken(token);
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Navigate to={`/registrations${window.location.search}`} replace />} />
        <Route
          path="/registrations"
          element={<RegistrationForm marketplaceToken={marketplaceToken} />}
        />
        <Route path="/registrations/complete" element={<SuccessPage />} />
      </Routes>
    </div>
  );
}

export default App;
